import { inject } from '@angular/core';
import {CanActivateFn, CanMatchFn, Router} from '@angular/router';

import {StoreDbService} from '../db/store.db.service';
import {DbStore} from '../db/models/db-store.model';
import {TipoPuntoVentaEnum} from '../../shared/enums/tipo-punto-venta-enum';
import {AuthService} from '../auth/auth-service';

export const authGuard: CanActivateFn  = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const storeDb = inject(StoreDbService);
  const storeDbService = inject(StoreDbService);
  const exists = await storeDb.hasStore();
  let store: DbStore | undefined;
  if (exists) {
    store = await storeDbService.getConfig();
    if (store) {
      if(store.tipoPV === TipoPuntoVentaEnum.Corporativo){
        if (await auth.isCorporateSessionValid()) {
          return true;
        }
        await router.navigate(['/login'], {
          state: {skipConfirm: true},
          replaceUrl: true
        });

        return false;
      } else if(store.tipoPV !== TipoPuntoVentaEnum.Corporativo){
          return true;
      }
    }

  } else {
    return router.createUrlTree(['/login']);
  }
  return router.createUrlTree(['/login']);

};


export const noAuthGuard: CanMatchFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isCorporateSessionValid()
    .then(isValid =>
      isValid
        ? router.createUrlTree(['/dashboard'])
        : true
    );
};
